module.exports = [{"name":"Map of Vancouver Disaster Support Hubs [https://goo.gl/FaKnZL]","quantity":1,"perishable":false,"shareable":true}]


//////////////////
// WEBPACK FOOTER
// ./src/basekits/cities/vancouver.json
// module id = 292
// module chunks = 0